export default __webpack_public_path__ + "static/media/universalm.b6b36a77.svg";